import { createContext as t, useContext as e } from "react";
const o = t({
  onClick: () => {
  },
  onResponse: () => {
  },
  onEvent: () => {
  }
}), s = () => e(o);
export {
  o as default,
  s as useUIContext
};
//# sourceMappingURL=context.js.map
